
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career-events",
      function () {
        return require("private-next-pages/career-events/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career-events"])
      });
    }
  